<app-alert></app-alert>
<form [formGroup]="termSheetForm" class="well">

  <div class="modal-body">
    <div class="col-md-12 form-group">
      <table>
        <tbody>
          <tr *ngFor="let termsheetElement of termsheetDataListArray; let i = index" style="line-height: 25px;">
            <td style="width:512px"><label class="form-control-label">{{termsheetElement.FieldName}}</label></td>

            <!-- Other Fields than Multi-Option -->
            <td
              *ngIf="termsheetElement.FieldName != 'Tenor' && termsheetElement.FieldName != 'Coupon Rate' && termsheetElement.FieldName != 'Coupon Type' && termsheetElement.FieldName != 'Pay-in Date' && termsheetElement.FieldName != 'Deemed Date of Allotment' && termsheetElement.FieldName != 'Redemption Date' && termsheetElement.FieldName != 'Redemption Premium / Discount' && termsheetElement.FieldName != 'Redemption Amount' && termsheetElement.FieldName != 'Issue Price' && termsheetElement.FieldName != 'Face Value'"
              style="width: 1500px;">
              <textarea class="form-control" readonly [formControlName]="termsheetElement.FieldName"></textarea>
            </td>

            <!-- Pay-in-Date -->
            <td
              *ngIf="termsheetElement.FieldName == 'Pay-in Date' || termsheetElement.FieldName == 'Deemed Date of Allotment'"
              style="width: 1500px;">
              <div *ngFor="let payinDate of payinDateArray;let j = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{j + 1}} : {{payinDate}}"></textarea>
              </div>
            </td>

            <!-- Redemption Date -->
            <td *ngIf="termsheetElement.FieldName == 'Redemption Date'" style="width: 1500px;">
              <div *ngFor="let redemptionDate of redemptionDateArray;let k = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{k + 1}} : {{redemptionDate}}"></textarea>
              </div>
            </td>

            <!-- Tenor -->
            <td *ngIf="termsheetElement.FieldName == 'Tenor'" style="width: 1500px;">
              <div *ngFor="let tenor of tenorArray;let l = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{l + 1}} : {{tenor}}"></textarea>
              </div>
            </td>

            <!-- Coupon Rate -->
            <td *ngIf="termsheetElement.FieldName == 'Coupon Rate'" style="width: 1500px;">
              <div *ngFor="let couponRate of couponRateArray;let m = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{m + 1}} : {{couponRate}}"></textarea>
              </div>
            </td>

            <!-- Coupon Type -->
            <td *ngIf="termsheetElement.FieldName == 'Coupon Type'" style="width: 1500px;">
              <div *ngFor="let couponType of couponTypeArray;let n = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{n + 1}} : {{couponType}}"></textarea>
              </div>
            </td>

            <!-- Redemption Premium / Discount -->
            <td *ngIf="termsheetElement.FieldName == 'Redemption Premium / Discount'" style="width: 1500px;">
              <div *ngFor="let redemptionPremiumDiscount of redemptionPremiumDiscountArray;let o = index;"
                style="margin-top: 3px;">
                <textarea class="form-control" readonly
                  value="Option{{o + 1}} : {{redemptionPremiumDiscount}}"></textarea>
              </div>
            </td>

            <!-- Redemption Amount -->
            <td *ngIf="termsheetElement.FieldName == 'Redemption Amount'" style="width: 1500px;">
              <div *ngFor="let redemptionAmount of redemptionAmountArray;let p = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{p + 1}} : {{redemptionAmount}} /-"></textarea>
              </div>
            </td>

            <!-- Issue Price OR Face Value-->
            <td *ngIf="termsheetElement.FieldName == 'Issue Price' || termsheetElement.FieldName == 'Face Value'" style="width: 1500px;">
              <div *ngFor="let issuePriceOrFaceValue of issuePriceOrFaceValueArray;let q = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{q + 1}} : {{issuePriceOrFaceValue}} /-"></textarea>
              </div>
            </td>

            <!-- Face Value -->
            <!-- <td *ngIf="termsheetElement.FieldName == 'Face Value'" style="width: 1500px;">
              <div *ngFor="let faceValue of faceValueArray;let q = index;" style="margin-top: 3px;">
                <textarea class="form-control" readonly value="Option{{q + 1}} : {{faceValue}} /-"></textarea>
              </div>
            </td> -->

            <td style="width: 60px;"><select
                *ngIf="!termsheetElement.systemGenerated && dropdownList[i][0] != undefined && termsheetElement.FieldName != 'Rating of the Instrument'" class="form-control"
                name="{{termsheetElement.FieldName}}" id="{{'defaultValue' + i}}"
                [formControlName]="termsheetElement.DefaultValue" style="padding:6px;" required="required"
                (change)="changeValueFromDropdown($event, termsheetElement.FieldName)">
                <option *ngFor="let valueList of dropdownList[i];" value="{{valueList}}">{{valueList}}
                </option>
              </select></td>

            <td style='white-space: nowrap !important'>
              <button
                *ngIf="!termsheetElement.systemGenerated && termsheetElement.FieldName != 'Tenor' && termsheetElement.FieldName != 'Coupon Rate' && termsheetElement.FieldName != 'Coupon Type' && termsheetElement.FieldName != 'Pay-in Date' && termsheetElement.FieldName != 'Deemed Date of Allotment' && termsheetElement.FieldName != 'Redemption Date' && termsheetElement.FieldName != 'Redemption Premium / Discount' && termsheetElement.FieldName != 'Redemption Amount' && termsheetElement.FieldName != 'Issue Price' && termsheetElement.FieldName != 'Face Value'"
                (click)="editModalForTermSheet(termsheetElement)" class="btn btn-sm btn-warning"
                style="width: 62px;"><span class="fa fa-pencil"></span></button>
            </td>
          </tr>
          <!-- <tr>
              <td style="width:512px"><label class="form-control-label">Selected Checkers</label></td>
              <td style="width: 1500px;"><textarea class="form-control" readonly>PartC</textarea></td>
          </tr> -->
        </tbody>
      </table>


    </div>
    <div class="modal-footer">
      <button type="Submit" class="btn-sm btn btn-primary" (click)="updateTermsheet()" [disabled]= "disabledOnClick">
        <span id="updatePartBDetails">Update</span>
      </button>
      <!-- <button type="Submit" class="btn-sm btn btn-primary" (click)="SubmitTermSheetForApprovalByChecker()" [disabled]= "disabledOnClick">
        <span id="updatePartBDetails">Submit term sheet for approval by checker</span>
      </button> -->

      <button type="Submit" class="btn-sm btn btn-primary" (click)="generateTermsheetDoc()" [disabled]= "disabledOnClick">
        <span id="updatePartBDetails">Generate Termsheet</span>
      </button>
    </div>
    <!-- </div> -->
    <!-- </div> -->


  </div>

</form>